// src/v2/components/AppAuthBootstrap.jsx
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../modal/Loading";
import WsProvider from "../ws/WsProvider";
import {fetchProfile} from "../../store/authSlice";

export default function AppAuthBootstrap({ children }) {
  const dispatch = useDispatch();
  const status = useSelector((s) => s.auth.status);
  const isLoading = status === "loading";

  const didInit = useRef(false);

  useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;
    dispatch(fetchProfile());
  }, [dispatch]);

  return (
    <>
      {isLoading ? <Loading/> : null}
      <WsProvider>{children}</WsProvider>
    </>
  );
}